/* This example requires Tailwind CSS v2.0+ */
const faqs = [
  {
    id: 1,
    question: 'How much KARMA can I earn per week?',
    answer: `Each week you will earn 5 KARMA for every AlgoDaruma you have staked.`,
  },
  {
    id: 2,
    question: 'When/how do I receive the KARMA?',
    answer: `Once a week the KARMA will be air dropped directly to your wallet for every AlgoDaruma you have staked.`,
  },
  {
    id: 3,
    question: 'What happens when I list/sell/transfer an AlgoDaruma that is being staked?',
    answer:
      'Your AlgoDaruma will be unstaked as soon as you list or transfer your AlgoDaruma to another wallet. You will not receive the weekly rewards.',
  },
];

export default function StakingInfo() {
  return (
    <div className='mt-12 md:mt-36'>
      <div className='max-w-6xl mx-auto'>
        <div className='bg-gray-800 rounded-lg'>
          <div className='px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8'>
            <h2 className='text-3xl font-extrabold text-gray-50'>How does staking work?</h2>
            <div className='pt-10 mt-6 border-t border-gray-300 border-opacity-25'>
              <dl className='space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12'>
                {faqs.map((faq) => (
                  <div key={faq.id}>
                    <dt className='text-lg font-medium leading-6 text-gray-50'>{faq.question}</dt>
                    <dd className='mt-2 text-base text-gray-400'>{faq.answer}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
